// extracted by mini-css-extract-plugin
export default {"container":"popover-module__container___MCaSW","isClosed":"popover-module__isClosed___hHYS7","content":"popover-module__content___vhPaR","pointer":"popover-module__pointer___Gtkq2"};